<template>
  <QuotationForm :step="1">
    <PersonalDataForm />
  </QuotationForm>
</template>

<script>
import QuotationForm from '@/components/forms/QuotationForm';
import PersonalDataForm from '@/components/forms/PersonalDataForm';

export default {
  name: "PersonalDataView",
  components: {
    QuotationForm,
    PersonalDataForm
  }
}
</script>

<style scoped lang="scss">
</style>